import { render, staticRenderFns } from "./CreateAccountFormUser.vue?vue&type=template&id=8cd40310&scoped=true&"
import script from "./CreateAccountFormUser.vue?vue&type=script&lang=js&"
export * from "./CreateAccountFormUser.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccountFormUser.vue?vue&type=style&index=0&id=8cd40310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd40310",
  null
  
)

export default component.exports